import React from 'react';
import PropTypes from 'prop-types';

const VoterId = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 3H14.5C14.8978 3 15.2794 3.18061 15.5607 3.5021C15.842 3.82359 16 4.25963 16 4.71429V13.2857C16 13.7404 15.842 14.1764 15.5607 14.4979C15.2794 14.8194 14.8978 15 14.5 15H2.5C2.10218 15 1.72064 14.8194 1.43934 14.4979C1.15804 14.1764 1 13.7404 1 13.2857V4.71429C1 4.25963 1.15804 3.82359 1.43934 3.5021C1.72064 3.18061 2.10218 3 2.5 3ZM2.5 4.71429V13.2857H14.5V4.71429H2.5ZM9.25 6.42857H13C13.1989 6.42857 13.3897 6.51888 13.5303 6.67962C13.671 6.84037 13.75 7.05839 13.75 7.28571C13.75 7.51304 13.671 7.73106 13.5303 7.89181C13.3897 8.05255 13.1989 8.14286 13 8.14286H9.25C9.05109 8.14286 8.86032 8.05255 8.71967 7.89181C8.57902 7.73106 8.5 7.51304 8.5 7.28571C8.5 7.05839 8.57902 6.84037 8.71967 6.67962C8.86032 6.51888 9.05109 6.42857 9.25 6.42857ZM9.25 9H13C13.1989 9 13.3897 9.09031 13.5303 9.25105C13.671 9.4118 13.75 9.62981 13.75 9.85714C13.75 10.0845 13.671 10.3025 13.5303 10.4632C13.3897 10.624 13.1989 10.7143 13 10.7143H9.25C9.05109 10.7143 8.86032 10.624 8.71967 10.4632C8.57902 10.3025 8.5 10.0845 8.5 9.85714C8.5 9.62981 8.57902 9.4118 8.71967 9.25105C8.86032 9.09031 9.05109 9 9.25 9ZM4 6.42857H6.25C6.44891 6.42857 6.63968 6.51888 6.78033 6.67962C6.92098 6.84037 7 7.05839 7 7.28571V9.85714C7 10.0845 6.92098 10.3025 6.78033 10.4632C6.63968 10.624 6.44891 10.7143 6.25 10.7143H4C3.80109 10.7143 3.61032 10.624 3.46967 10.4632C3.32902 10.3025 3.25 10.0845 3.25 9.85714V7.28571C3.25 7.05839 3.32902 6.84037 3.46967 6.67962C3.61032 6.51888 3.80109 6.42857 4 6.42857Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

VoterId.propTypes = {
  fill: PropTypes.string,
};

export default VoterId;
